import { useContext, useRef, useState } from 'react'

import './index.scss'
import UserContext from '../../contexts/UserContext/context'
import Icon from '../Icon'
import { useTranslation } from 'react-i18next'
import { useClickOutside } from '../../hooks/useClickOutside'
import DropDownSelection from '../DropdownSelection'
import { removeUser } from '../../contexts/UserContext/actions'
import { useNavigate } from 'react-router-dom'
import { ICON } from '../Icon/data'

const UserProfileWidget = () => {
  const { t } = useTranslation()
  const { user, dispatch } = useContext(UserContext)
  const dropdownRef = useRef()
  const navigate = useNavigate()

  const { permissions } = user

  const [isOpen, setIsOpen] = useState<boolean>(false)

  useClickOutside(dropdownRef, () => setIsOpen(false))

  const options = [{
    label: t('Profile settings'),
    icon: ICON.COGWHEEL,
    onClick: () => {
      navigate('/profile-settings')
      setIsOpen(false)
    },
    permissions: !permissions?.trackwell?.user_profile
  }, {
    label: t('Logout'),
    icon: ICON.LOGOUT,
    onClick: () => dispatch(removeUser()),
    permissions: true
  }]

  if (!user.name) {
    return null
  }

  return (
    <div className="UserProfileWidget">
      <div
        className="UserProfileWidget__button"
        tabIndex={0}
        role="button"
        onClick={() => setIsOpen(!isOpen)}
      >
        <Icon icon={ICON.USER_FILLED} />
        <div className="UserProfileWidget__button-name">{user.name ?? ''}</div>
        <div className="UserProfileWidget__chevron">
          <Icon icon={isOpen ? ICON.CHEVRON_UP : ICON.CHEVRON_DOWN} size={24} color="#161616" />
        </div>
      </div>
      {isOpen && (
        <div ref={dropdownRef} className="UserProfileWidget__dropdown">
          <DropDownSelection options={options.filter((o) => o.permissions)} />
        </div>
      )}
    </div>
  )
}

export default UserProfileWidget
